<template>
    <div>
        <v-row>                
            <v-col cols="12">Total number of complaints <span class="ml-2 mr-2"><b>{{overview.numberOfClaims}}</b></span>  total amount claimed <span class="ml-2"><b>€ {{ overview.claimedAmount }}</b></span></v-col>    
        </v-row>        
        <v-row v-if="overview.numberOfClaims  > 0">
            <v-col cols="12">
                <v-data-table 
                        flat dense 
                        :headers="getHeaders()"
                        :items="overview.amounts" 
                        :disable-pagination=true 
                        hide-default-footer>
                    <template v-slot:item="amounts">
                        <tr>
                            <td>{{amounts.item.typeDescription}}</td>                                                    
                            <td class="row-pointer link-color" v-on:click="$router.open('/eign/onEign/' + amounts.item.eign_encrid)"><v-layout justify-start>{{amounts.item.code}}</v-layout></td>
                            <td><v-layout justify-start>{{amounts.item.description}}</v-layout></td>
                            <td><v-layout justify-end>{{amounts.item.claimedAmount}}</v-layout></td>
                        </tr>
                    </template>
                </v-data-table>                  
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            overview: Object,
        },     
        components: {            
        },      
        data() {
            return {
            }
        },
        methods: {    
            getHeaders(){
                return [
                    { text: "Type", value: "type", align: "start", width: "20%", sortable: false},
                    {text: 'Code', value: "code", align: "start", width: "15%", sortable: false},
                    {text: 'Name', value: "description", align: "start", width: "55%", sortable: false},
                    {text: 'Amount', value: "claimedAmount", align: "end", width: "12%", sortable: false}
                ];
            }                
        }
    }
</script>

<style scoped>
td{
    vertical-align: top;
    border-top: 3px solid transparent;    
    font-size: small !important;
}
.row-pointer {
    cursor: pointer;
}
.link-color {
    color: blue;
}
</style>